import React from 'react';
import styles from './styles.module.css';
import * as Icon from '../../Icons'
const AutoComplete = ({ type = 'text', ...props }) => {
  return (
    <div className={styles.autoComplete}>
      <div className={styles.icon}>
        <Icon.WorldPin/>
      </div>
      <input className={styles.input} type={type} {...props} />
    </div>
  );
};

export default AutoComplete;
